import transformador1 from '../../../../assets/img/desktop/3bbf5abb-a7a4-438c-9074-056fa39a9d4f.jpg';
import transformador2 from '../../../../assets/img/desktop/210929be-315b-43b0-b45d-c2913910603d.jpg';
import pozoTierra1 from '../../../../assets/img/desktop/8c07a9c2-9e45-4190-962a-dffe268c5b1e.jpg';
import pozoTierra2 from '../../../../assets/img/desktop/a8304a40-a204-46e4-b3af-c3d7b2a99bb0.jpg';
import tableroElectrico from '../../../../assets/img/desktop/f5818def-ee11-4a95-83e1-0f5be43092bb.png';
import './CMInfraestructuraElectrica.css';

function CMInfraestructuraElectrica() {

    return (
        <div id="CMInfraestructuraElectrica">
            <section id="IE__head">
                <h2>Infraestructura Eléctrica</h2>
                <ul>
                    <li>Inicio</li>
                    <li>/</li>
                    <li>Servicios</li>
                    <li>/</li>
                    <li>Infraestructura Eléctrica</li>
                </ul>
            </section>
            <section id="IE__section2">
                <figure id="IE-content">
                    <img src={transformador1} alt="Suministro e Instalación de Transformadores" />
                </figure>
                <div id="IE-text">
                    <p id="IE-text__p1">Tableros eléctricos y sistemas de protección<strong> para garantizar la seguridad y eficiencia energética.</strong></p>
                    <p id="IE-text__p2">Ofrecemos instalación, montaje, mantenimiento y ampliación de tableros eléctricos de distribución, fuerza, control y automatización industrial. 
                        Nuestros trabajos cumplen con normas nacionales e internacionales y son ejecutados por técnicos calificados y certificados, garantizando 
                        mayor seguridad eléctrica y operativa.</p>
                </div>
            </section>
            <section id="IE__section3">
                <div id="IEs3-content1">
                    <div id="IE3-content1__text">
                        <p id="IE3-content1__text--p1">A través de nuestro modelo de entrega único, <strong>INFRASOL</strong> provee servicios rentables; basados en Acuerdos de Niveles de Servicio (SLAs); soportados
                            por una metodología de entrega madura, alineada a las mejores prácticas y soportado en un sólido programa de calidad.</p>
                        <p id="IE3-content1__text--p2">Contamos con experiencia en planificación, diseño, implementación y gestión de proyectos de infraestructura eléctrica
                            para resolver los requerimientos técnicos o de negocios específicos de clientes, integrando tecnología y servicios.</p>
                        <p id="IE3-content1__text--p3">Nuestros servicios garantizan transformadores eficientes con bajas pérdidas y alta confiabilidad, instalación conforme a RETIE 
                            y normas eléctricas peruanas, y mayor seguridad y estabilidad del sistema eléctrico general.</p>
                        <p id="IE3-content1__text--p4">Nuestros servicios incluyen:</p>
                    </div>
                    <div id="IE3-content1__image">
                        <figure>
                            <img src={transformador2} alt="Transformadores Eléctricos" />
                        </figure>
                    </div>
                </div>
                <div id="IEs3-content2">
                    <div id="IEs3-content2__text1">
                        <div id="IEs3-content2__text1--i1">
                            <h3>Suministro e Instalación de Transformadores</h3>
                            <div></div>
                            <p>Realizamos el suministro, instalación y mantenimiento de transformadores eléctricos de distribución, potencia y aislamiento, 
                                en rangos desde 5 kVA hasta 2500 kVA, adaptados a tus requerimientos industriales, comerciales o institucionales. 
                                Trabajamos con equipos fabricados bajo normas IEC, ANSI y NTP, garantizando rendimiento y durabilidad.</p>
                        </div>
                        <div id="IEs3-content2__text1--i2">
                            <h3>Instalación y Mantenimiento de Pozo a Tierra</h3>
                            <div></div>
                            <p>Ejecutamos proyectos completos de pozos a tierra y sistemas de puesta a tierra adaptados a las condiciones del terreno y la carga eléctrica. 
                                Garantizamos resistencias menores a los valores exigidos por norma, mediante técnicas y materiales de alta eficiencia, cumpliendo con 
                                normas IEEE 80, IEC 60364 y RETIE.</p>
                            <div className="IEs3-content2__text1--i2__images">
                                <figure>
                                    <img src={pozoTierra1} alt="Instalación de Pozo a Tierra" />
                                </figure>
                                <figure>
                                    <img src={pozoTierra2} alt="Medición de Pozo a Tierra" />
                                </figure>
                            </div>
                        </div>
                    </div>
                    <div id="IEs3-content2__text2">
                        <h3 id="IEs3-content2__text2--i3">Instalación y Mantenimiento de Tableros Eléctricos</h3>
                        <div></div>
                        <ul>
                            <li>Tableros de distribución principal y secundaria, tableros de control de motores (CCM), tableros PLC, automatización y protección diferencial.</li>
                            <li>Tableros inteligentes con monitoreo remoto para optimización del consumo energético.</li>
                            <li>Montaje ordenado de componentes, etiquetado y canalización adecuada.</li>
                            <li>Verificación de protecciones, pruebas de continuidad y aislamiento.</li>
                            <li>Termografía infrarroja para detección de puntos calientes.</li>
                            <li>Actualización de planos unifilares y documentación técnica completa.</li>
                            <li>Mantenimiento preventivo con limpieza, torqueado y calibración.</li>
                            <li>Servicio de emergencia 24/7 y soporte técnico post-instalación.</li>
                            <li>Cumplimiento de las normas RETIE, NEC y IEC.</li>                        
                        </ul>
                        <div className="IEs3-content2__text2__image">
                            <figure>
                                <img src={tableroElectrico} alt="Mantenimiento de Tableros Eléctricos" />
                            </figure>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default CMInfraestructuraElectrica;

